import { render, staticRenderFns } from "./prompts.vue?vue&type=template&id=6c59aa5a"
import script from "./prompts.vue?vue&type=script&lang=js"
export * from "./prompts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports